import type { ApiErrorBody } from '@shared/api-error'

export class ApiError extends Error {
  code: ApiErrorBody['error']['code']
  fields?: Record<string, string>

  constructor(body: ApiErrorBody) {
    super(body.error.message)
    this.code = body.error.code
    this.fields = body.error.fields
  }
}

/** Every request carries the session cookie and throws a typed ApiError
 * on failure, so TanStack Query's onError sees one shape everywhere. */
export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: { 'content-type': 'application/json', ...init?.headers },
    ...init,
  })

  if (res.status === 204) return undefined as T

  const body = await res.json().catch(() => null)
  if (!res.ok) {
    throw new ApiError(body ?? { error: { code: 'internal_error', message: 'Something went wrong.' } })
  }
  return body as T
}
